<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>賃居訪視表</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>賃居訪視表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                學年度：
                <select v-model="search.schYearTerm">
                  <option v-for="item in schYearTermList" :key="item" :value="item.replace('/', '')">{{item}}</option>
                </select>
                <span v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'">&nbsp;系所：</span>
                <select v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'" v-model="search.deptCode">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in deptList" :key="index" :value="item.code">{{item.value}}</option>
                </select>
                <span v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'">&nbsp;班級：</span>
                <select v-if="loginInfo.accountType=='TCH' || loginInfo.accountType=='ADM'" v-model="search.dradeClass">
                  <option :value="null">請選擇</option>
                  <option v-for="(item, index) in dradeClassList" :key="index" :value="item.value">{{item.text}}</option>
                </select>
                訪視狀態：
                <select v-model="search.isVisit">
                  <option :value="null">請選擇</option>
                  <option :value="true">已完成</option>
                  <option :value="false">未完成</option>
                </select>
                變更地址：
                <select v-model="search.isAddrChanged">
                  <option :value="null">請選擇</option>
                  <option :value="true">是</option>
                  <option :value="false">否</option>
                </select>
                學生姓名或學號： <input type="text" v-model="search.keyword" />
              </div>
              <div align="center" style="padding:7px;">
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
                <a href="#" @click.prevent="searchClear" class="btn-upload btn btn-primary" style="background-color:#666; border-color:#666;">清空</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div v-if="pageAdmin">
                設定開放時間：
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="opening.startDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" /> -
                <datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="opening.endDate" input-class="form-control topIndex" :style="{width:'auto', display:'inline-block'}" />
                  學年度學期：
                <input type="text" v-model="opening.smtr" class="form-control topIndex" :style="{width:'70px', display:'inline-block'}" />
                <a href="#" @click.prevent="setOpeningDate" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">送出</a>
              </div>
              <div class="s_dil"><a href="#" @click.prevent="sendInstructor" class="btn-upload btn s_btn_o" v-if="isAdmin('tenancy')">通知校安人員</a></div>
              <div class="s_dir">
                <a href="#" @click.prevent="exportExcel" class="btn-upload btn s_btn_b">匯出填寫清冊</a>
                <a href="#" @click.prevent="download" class="btn-upload btn s_btn_b">{{isAdmin('tenancy') ? "家長回條匯出":"賃居表匯出"}}</a></div>
              <div style=" clear:both;">
                <table ref="table" class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="6%" style="padding-right: 8px !important;">
                        <input type="checkbox" ref="allChecked" @change.prevent="allCheckedChange">
                      </th>
                      <th class="text-center" width="8%">學年度</th>
                      <th class="text-center" width="19%">系所班級</th>
                      <th class="text-center" width="8%">學號</th>
                      <th class="text-center" width="8%">姓名</th>
                      <th class="text-center" width="24%">賃居地址</th>
                      <th class="text-center" width="8%">變更地址</th>
                      <th class="text-center" width="8%">訪視狀態</th>
                      <th class="text-center" width="7%">填寫人</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="勾選" class="text-center"><input type="checkbox" :value="item.schYearTerm + ';' + item.studentId" v-model="checked" /></td>
                      <td data-title="學年度" class="text-center">{{item.schYearTerm}}</td>
                      <td data-title="班級" class="text-center">{{item.deptName}}{{item.dradeClass}}</td>
                      <td data-title="學號" class="text-center">{{item.studentId}}</td>
                      <td data-title="姓名" class="text-center">{{item.studentName}}</td>
                      <td data-title="賃居地址" class="text-center">{{item.tenancyAddress}}</td>
                      <td data-title="變更地址" class="text-center"><span v-if="item.isAddrChanged" style="color:red">是</span><span v-else>否</span></td>
                      <td data-title="訪視狀態" class="text-center">
                        <router-link :to="'/tenancy-visit/edit/' + item.schYearTerm.replace('/', '|') + '/' + item.studentId">{{item.isVisit}}</router-link>
                      </td>
                      <td data-title="填寫人" class="text-center">{{item.visitUser}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      pageAdmin: false,
      loginInfo: {},
      isTenancy: false,
      search: {
        schYearTerm: null,
        deptCode: null,
        dradeClass: null,
        isVisit: null,
        isAddrChanged: null,
        keyword: null,
      },
      allDradeClassList: [],
      dradeClassList: [],
      opening: {
        startDate: null,
        endDate: null,
        smtr: null,
      },
      list: [],
      schYearTermList: [],
      deptList: [],
      checked: [],
    };
  },
  computed: {
    searchSchYearTerm() {
      return this.search.schYearTerm;
    },
    searchDeptCode() {
      return this.search.deptCode;
    }
  },
  async mounted() {
    this.pageAdmin = await this.isAdmin("tenancy");
    let d = this.nowDate();

    // 並行取得登入資訊與開放時間，減少等待時間
    const [loginRes, openingRes] = await Promise.all([
      this.$http.get("/api/shared/login-info"),
      this.$http.get("/api/tenancyVisit/opening-date"),
    ]);

    this.loginInfo = loginRes.body;
    if (openingRes.body) {
      this.opening.startDate = openingRes.body.startDate;
      this.opening.endDate = openingRes.body.endDate;
      this.opening.smtr = openingRes.body.smtr == null ? "" : String(openingRes.body.smtr);
      this.search.schYearTerm = this.opening.smtr;
    }

    // 非管理員與非教師，需驗證開放時間
    if (!this.pageAdmin && this.loginInfo.accountType != 'TCH') {
      if (!this.opening.startDate || this.opening.startDate == "" ||
          !this.opening.endDate || this.opening.endDate == "") {
        alert("功能尚未開放");
        this.$router.go(-1);
        return;
      }
      let sd = new Date(this.opening.startDate);
      let ed = new Date(this.opening.endDate);
      ed.setDate(ed.getDate() + 1);
      if (d < sd || d > ed) {
        alert("功能尚未開放");
        this.$router.go(-1);
        return;
      }
    }

    this.$http.get("/api/shared/check-tenancy-safety").then(a => {
      this.isTenancy = a.body;
    });

    let nowSchYear = d.getFullYear() - 1911;
    for (let i = nowSchYear; i >= 108; i--) {
      if (i == nowSchYear) {
        let month = d.getMonth() + 1;
        if (month < 8) continue;
        else this.schYearTermList.push(i.toString() + "/1");
      } else {
        this.schYearTermList.push(i.toString() + "/2");
        this.schYearTermList.push(i.toString() + "/1");
      }
    }

    // 管理員若開放時間未設定學年度學期，預設選第一個
    if (!this.search.schYearTerm && this.schYearTermList.length > 0) {
      this.search.schYearTerm = this.schYearTermList[0].replace("/", "");
    }

    const deptApi = this.isAdmin("military")
      ? "/api/shared/full-dept-list"
      : "/api/shared/full-dept-list-by-tch-stage/" + this.search.schYearTerm;

    // 並行取得系所清單與班級清單
    Promise.all([
      this.$http.get(deptApi),
      this.$http.get("/api/shared/dradeclass-list"),
    ]).then(([deptRes, dradeClassRes]) => {
      this.deptList = deptRes.body;
      this.allDradeClassList = dradeClassRes.body;
    });

    this.load();
  },
  methods: {
    load() {
      if ($.fn.DataTable.isDataTable(this.$refs.table)) {
        $(this.$refs.table).DataTable().destroy();
      }
      this.$http
        .get("/api/tenancyVisit", {
          params: {
            schYearTerm: this.search.schYearTerm,
            deptCode: this.search.deptCode,
            dradeClass: this.search.dradeClass,
            isVisit: this.search.isVisit,
            isAddrChanged: this.search.isAddrChanged,
            keyword: this.search.keyword,
          },
        })
        .then((a) => {
          this.list = a.body;
          this.$nextTick((b) => {
            $(this.$refs.table).DataTable({
              bFilter: false,
              bLengthChange: false,
              language: {
                info: "第 _PAGE_ 頁 / 總共 _PAGES_ 頁",
              },
              columnDefs: [
                {
                  targets: 0,
                  orderable: false,
                },
              ],
              order: [3, "asc"],
              columns: [
                { width: "6%" },
                { width: "8%" },
                { width: "19%" },
                { width: "8%" },
                { width: "8%" },
                { width: "24%" },
                { width: "8%" },
                { width: "8%" },
                { width: "7%" }
              ]
            });
          });
        });
    },
    setOpeningDate() {
      if (this.opening.startDate == "" || this.opening.endDate == "") {
        alert("『開放時間』 尚未填寫");
        return false;
      }
      const smtr = this.opening.smtr == null ? "" : String(this.opening.smtr).trim();
      if (!smtr) {
        alert("請輸入學年度學期");
        return false;
      }
      this.opening.smtr = smtr;
      this.$http
        .post("/api/tenancyVisit/opening-date", this.opening)
        .then(a => {
          if (a.body.status) {
            alert("儲存成功");
          } else {
            alert(a.body.msg);
          }
        });
    },
    searchSubmit() {
      this.load();
    },
    searchClear() {
      this.search.schYearTerm = this.schYearTermList[0].replace("/", "");
      this.search.deptCode = null;
      this.search.dradeClass = null;
      this.search.isVisit = null;
      this.search.isAddrChanged = null;
      this.search.keyword = null;
      this.load();
    },
    setDradeClassList() {
      if (this.searchSchYearTerm == null || this.searchDeptCode == null) {
        this.dradeClassList = [];
        this.search.dradeClass = null;
      } else {
        this.dradeClassList = this.allDradeClassList.filter(a => {
          return (
            a.schYearTerm == this.searchSchYearTerm &&
            this.searchDeptCode.endsWith(a.deptCode)
          );
        });
      }
    },
    allCheckedChange(e) {
      this.checked = [];
      if ($(e.target).prop("checked") == true) {
        this.list.forEach((a) => {
          this.checked.push(a.schYearTerm + ";" + a.studentId);
        });
      }
    },
    sendInstructor() {
      if (this.checked.length == 0) {
        alert("尚未勾選任何資料");
        return false;
      }
      this.$http
        .post("/api/tenancyVisit/send-instructor", this.checked)
        .then((a) => {
          alert(a.body.msg);
          if (a.body.status) {
            $(this.$refs.allChecked).prop("checked", false);
            this.checked = [];
            this.load();
          } else {
            console.log(a.body.exstr);
          }
        });
    },
    download() {
      if (this.checked.length == 0) {
        alert("尚未勾選任何資料");
        return false;
      }
      this.$http
        .post("/api/tenancyVisit/export", this.checked, {
          responseType: "arraybuffer",
        })
        .then((res) => {
          $(this.$refs.allChecked).prop("checked", false);
          this.checked = [];
          this.download2File(res);
        });
    },
    exportExcel() {
      this.$http
        .post(
          "/api/tenancyVisit/export-excel?schYearTerm=" +
            this.search.schYearTerm +
            "&deptCode=" +
            (this.search.deptCode ? this.search.deptCode : "") +
            "&dradeClass=" +
            (this.search.dradeClass ? this.search.dradeClass : "") +
            "&isVisit=" +
            (this.search.isVisit === null || this.search.isVisit === undefined
              ? ""
              : this.search.isVisit) +
            "&isAddrChanged=" +
            (this.search.isAddrChanged === null ||
            this.search.isAddrChanged === undefined
              ? ""
              : this.search.isAddrChanged) +
            "&keyword=" +
            (this.search.keyword ? this.search.keyword : ""),
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        });
    },
  },
  watch: {
    searchSchYearTerm() {
      const api = this.isAdmin("military")
        ? "/api/shared/full-dept-list"
        : "/api/shared/full-dept-list-by-tch-stage/" + this.search.schYearTerm;
      this.$http.get(api).then(a => {
        this.deptList = a.body;
      });
      this.setDradeClassList();
    },
    searchDeptCode() {
      this.setDradeClassList();
    }
  }
};
</script>

<style>
</style>